// extracted by mini-css-extract-plugin
export var card = "Section-module--card--381df";
export var emptySpace = "Section-module--emptySpace--bc3c0";
export var extraMarginBottom = "Section-module--extraMarginBottom--1d734";
export var extraMarginTop = "Section-module--extraMarginTop--29974";
export var full = "Section-module--full--281d4";
export var half = "Section-module--half--c0157";
export var pricing = "Section-module--pricing--d25d7";
export var reverse = "Section-module--reverse--f28f6";
export var section = "Section-module--section--e6268";
export var smallTextMargin = "Section-module--smallTextMargin--9b424";
export var smallerImage = "Section-module--smallerImage--6a25e";
export var table = "Section-module--table--79d56";
export var text = "Section-module--text--0518e";
export var widerImage = "Section-module--widerImage--3f892";
export var wrapper = "Section-module--wrapper--a83bb";